var _defs, _path, _path2, _path3, _path4, _circle, _ellipse, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.295,
    height: 54.295,
    viewBox: "0 0 54.295 54.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f067ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M27.147,14.245C24.369,14.245,0,14.046,0,7.122S24.369,0,27.147,0,54.295.2,54.295,7.122,29.926,14.245,27.147,14.245ZM3.593,7.122c1.656,1.349,9.6,3.561,23.555,3.561S49.046,8.471,50.7,7.122c-1.656-1.349-9.6-3.561-23.555-3.561S5.249,5.774,3.593,7.122Zm47.37.275h0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M27.147,17.153C24.369,17.153,0,16.954,0,10.031A1.741,1.741,0,0,1,1.7,8.25,1.729,1.729,0,0,1,3.382,9.826c1.045,1.313,9.076,3.765,23.765,3.765s22.72-2.453,23.765-3.765a1.694,1.694,0,0,1,3.382.2c0,6.923-24.369,7.122-27.147,7.122ZM50.9,10.028Zm-47.508,0Z",
    transform: "translate(0 10.243)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M27.147,23.153C24.369,23.153,0,22.954,0,16.031A1.741,1.741,0,0,1,1.7,14.25a1.729,1.729,0,0,1,1.685,1.576c1.045,1.313,9.076,3.765,23.765,3.765s22.72-2.453,23.765-3.765a1.694,1.694,0,0,1,3.382.2c0,6.923-24.369,7.122-27.147,7.122ZM50.9,16.028Zm-47.508,0Z",
    transform: "translate(0 17.692)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M27.147,51.2C24.369,51.2,0,51.014,0,44.451V3.938a1.7,1.7,0,0,1,3.393,0V44.269c1.088,1.251,9.117,3.558,23.754,3.558S49.813,45.52,50.9,44.269V3.938a1.7,1.7,0,0,1,3.393,0V44.451C54.295,51.014,29.926,51.2,27.147,51.2Z",
    transform: "translate(0 3.092)",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(8.693 29.275)",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2.333,
    cy: 2.439,
    rx: 2.333,
    ry: 2.439,
    transform: "translate(8.693 15.489)",
    fill: "url(#linear-gradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2.333,
    cy: 2.492,
    rx: 2.333,
    ry: 2.492,
    transform: "translate(8.693 42.384)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices6);
export default __webpack_public_path__ + "static/media/services6.d6a3f37a1b487cb62b2c369f43ce45f0.svg";
export { ForwardRef as ReactComponent };